import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/dvd/components/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/dvd/components/Section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/dvd/modules/Cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/dvd/modules/FeatureList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/dvd/modules/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/dvd/modules/MediaAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","ScrollingChild"] */ "/usr/src/app/src/dvd/modules/Scrolling.tsx");
